import React from 'react';

import {withCssModule} from '@pb/kit-util-with-css-module';

import {Tabs} from './tabs.component';
import styles from './tabs.component.module.styl';

import type {TabsProps} from './tabs.component';


const classNames = withCssModule(styles);

export const TertiaryTabs = (props: TabsProps) => {
    return <Tabs {...props} rootProps={{className: classNames('tabs_th-level', props.rootProps?.className)}}/>;
};

TertiaryTabs.displayName = 'TertiaryTabs';
